import React from 'react';

interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  size?: 'sm' | 'md';
  label?: string;
  className?: string;
  disabled?: boolean;
}

const Toggle: React.FC<ToggleProps> = ({ checked, onChange, size = 'sm', label, className = '', disabled }) => {
  const sizes = {
    sm: { outer: 'h-5 w-9', inner: 'h-4 w-4', translate: 'translate-x-4' },
    md: { outer: 'h-6 w-11', inner: 'h-5 w-5', translate: 'translate-x-5' }
  } as const;
  const s = sizes[size];

  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      onClick={() => !disabled && onChange(!checked)}
      className={`group inline-flex items-center gap-2 ${className}`}
    >
      <span
        className={`relative ${s.outer} rounded-full transition-colors duration-200 ease-out focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-black ${
          checked ? 'bg-black' : 'bg-gray-300'
        } ${disabled ? 'opacity-60 cursor-not-allowed' : 'cursor-pointer'}`}
      >
        <span
          className={`absolute left-0.5 top-0.5 ${s.inner} rounded-full bg-white shadow transform transition-transform duration-200 ease-out ${
            checked ? s.translate : 'translate-x-0'
          }`}
        />
      </span>
      {label && (
        <span className="text-sm text-gray-800 select-none">{label}</span>
      )}
    </button>
  );
};

export default Toggle;
